import { Topbar } from '../../components/Topbar/Topbar';
import { Footer } from '../../components/Footer/Footer';
import { Alert, Button, Container } from 'react-bootstrap';
import { Faq } from '../../components/Faq/Faq';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { Link, useHistory } from 'react-router-dom';
import { TicketForm } from '../../components/TicketForm/TicketForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faHeadset, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { useEffect } from 'react';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { useMobileDetect } from '../../../hooks/useMobileDetect';
import { useCapacitor } from '../../../hooks/useCapacitor';
import { useTranslation } from 'react-i18next';
import { Title } from '../../components/Title/Title';
import { useGeolocation } from '../../../contexts/GeolocationContext';
import { isItalian } from '../../utils/utils';

const HelpComponent = () => {
  const { currentUser, staticData, getStaticData } = useFirebase();
  const history = useHistory();
  const { isMobile } = useMobileDetect();
  const { isNative, platform } = useCapacitor();
  const { t } = useTranslation();
  const { country_code } = useGeolocation();

  useEffect(() => {
    if (!Object.keys(staticData).length) {
      getStaticData();
    }
  }, []);

  return (
    <>
      <Title>{t('help.labels.titolo')}</Title>

      <div style={{ marginBottom: '72px' }}>
        <div style={{ backgroundColor: '#141414', position: 'fixed', top: '0', left: '0', right: '0', zIndex: 100 }}>
          <Topbar />
        </div>
      </div>

      <Container className={'my-5'}>
        <div className={'display-4'}>{t('help.labels.assistenzaSupporto')}</div>
        <p>{t('help.labels.aiutoDescrizione')}</p>
        <Faq />
        <h2>{t('help.labels.aiutoDescrizione2')}</h2>
        <p>{t('help.labels.aiutoDescrizione3')}</p>
        {!currentUser && <Alert variant={'warning'}>{t('help.labels.aiutoDescrizione4')}</Alert>}
        {!!currentUser && <TicketForm onSuccess={(ticketId) => history.push(`/ticket/${ticketId}`)} />}

        {!Object.keys(staticData).length && <FullscreenLoader fullscreen={false} />}

        {!!currentUser && (
          <>
            <h2 className={'mt-5'}>{t('help.labels.storicoTicket')}</h2>
            <p>{t('help.labels.verificaStatoTicket')}</p>
            <Button variant={'info'} as={Link} to={'/tickets'}>
              {t('help.labels.vediTuoiTicket')}
            </Button>
          </>
        )}

        {staticData.ENABLE_MESSENGER && (
          <>
            <h2 className={'mt-5'}>{t('help.labels.scriviSuMessanger')}</h2>
            <iframe
              width="280"
              height="50"
              style={{ border: 0 }}
              src={`https://cdn.smooch.io/message-us/index.html?channel=messenger&color=blue&size=standard&radius=8px&label=${t(
                'help.labels.scriviSuMessanger'
              )}&pageId=433524160496487`}
            />
          </>
        )}

        {!!(staticData.SUPPORT_EMAIL || (staticData.SUPPORT_PHONE && isItalian(country_code))) && (
          <>
            <h2 className={'mt-5'}>{t('help.labels.altriCanali')}</h2>
            {!!staticData.SUPPORT_EMAIL && (
              <div className={'mb-4'}>
                {t('help.labels.puoiInviareMailA')}
                <Button variant={'outline-light'} as={'a'} href={'mailto:' + staticData.SUPPORT_EMAIL} className={'ml-2'} size={'sm'}>
                  <FontAwesomeIcon icon={faAt} className={'mr-2'} /> <span>{staticData.SUPPORT_EMAIL}</span>
                </Button>
              </div>
            )}
            {!!staticData.SUPPORT_PHONE && isItalian(country_code) && (
              <div className={'mb-4'}>
                {t('help.labels.puoiTelefonareA')}
                <Button variant={'outline-light'} as={'a'} href={'tel:' + staticData.SUPPORT_PHONE} className={'ml-2'} size={'sm'}>
                  <FontAwesomeIcon icon={faPhoneAlt} className={'mr-2'} /> <span>{staticData.SUPPORT_PHONE}</span>
                </Button>
                {!!staticData.SUPPORT_HOURS && <div>{t('help.labels.numeroAttivoAlle', { hours: staticData.SUPPORT_HOURS })}</div>}
              </div>
            )}
          </>
        )}

        {!isMobile && !!staticData.REMOTE_SUPPORT_DOWNLOAD_URL && (
          <>
            <h2 className={'mt-5'}>{t('help.labels.assistenzaRemoto')}</h2>
            <p>
              {t('help.labels.necessitiSupporto')}
              <br />
              {t('help.labels.clickPerDownload')}
            </p>
            <Button variant={'info'} size={'lg'} as={'a'} href={staticData.REMOTE_SUPPORT_DOWNLOAD_URL} target={'_blank'}>
              <FontAwesomeIcon icon={faHeadset} className={'mr-2'} />{' '}
              <span>{t('help.labels.scaricaSoftware', { name: staticData.REMOTE_SUPPORT_SOFTWARE_NAME || 'il software' })}</span>
            </Button>
          </>
        )}

        {isNative && platform == 'ios' && !!staticData.REMOTE_SUPPORT_DOWNLOAD_URL_IOS && (
          <>
            <h2 className={'mt-5'}>{t('help.labels.assistenzaRemoto')}</h2>
            <p>
              {t('help.labels.necessitiSupporto')}
              <br />
              {t('help.labels.clickPerDownload')}
            </p>
            <Button variant={'info'} size={'lg'} as={'a'} href={staticData.REMOTE_SUPPORT_DOWNLOAD_URL_IOS} target={'_blank'}>
              <FontAwesomeIcon icon={faHeadset} className={'mr-2'} />{' '}
              <span>{t('help.labels.scaricaSoftware', { name: staticData.REMOTE_SUPPORT_SOFTWARE_NAME_IOS || t('help.labels.softwareGenerico') })}</span>
            </Button>
          </>
        )}

        {isNative && platform == 'android' && !!staticData.REMOTE_SUPPORT_DOWNLOAD_URL_ANDROID && (
          <>
            <h2 className={'mt-5'}>{t('help.labels.assistenzaRemoto')}</h2>
            <p>
              {t('help.labels.necessitiSupporto')}
              <br />
              {t('help.labels.clickPerDownload')}
            </p>
            <Button variant={'info'} size={'lg'} as={'a'} href={staticData.REMOTE_SUPPORT_DOWNLOAD_URL_ANDROID} target={'_blank'}>
              <FontAwesomeIcon icon={faHeadset} className={'mr-2'} />{' '}
              <span>{t('help.labels.scaricaSoftware', { name: staticData.REMOTE_SUPPORT_SOFTWARE_NAME_ANDROID || t('help.labels.softwareGenerico') })}</span>
            </Button>
          </>
        )}
      </Container>

      <Footer />
    </>
  );
};

export default HelpComponent;
